import { AxiosResponse } from "axios";
import { Variable, VariablePatch, VariablePost } from "generated/models/Event";
import {
    createErrorResponseStandard,
    createResponseStandard,
    orgId,
} from "utils/functions";
import { eventVariableClient } from "./eventVariableServiceClients";

class EventVariableService {
    async readEventVariables() {
        try {
            const response: AxiosResponse =
                await eventVariableClient.getEventVariablesByOrganisationId({
                    organisation_uuid: orgId(),
                });
            return createResponseStandard<Variable[]>(response);
        } catch (error) {
            return createErrorResponseStandard(error);
        }
    }

    async getEventVariableById(id: string) {
        try {
            const response: AxiosResponse =
                await eventVariableClient.getEventVariableById(id);
            return createResponseStandard<Variable>(response);
        } catch (error) {
            return createErrorResponseStandard(error);
        }
    }

    async createEventVariable(eventVariable: VariablePost) {
        try {
            const response: AxiosResponse =
                await eventVariableClient.createEventVariable(eventVariable);
            return createResponseStandard<Variable>(response);
        } catch (error) {
            return createErrorResponseStandard(error);
        }
    }

    async updateEventVariable(id: string, payload: VariablePatch) {
        try {
            const response: AxiosResponse =
                await eventVariableClient.updateEventVariableById(id, payload);
            return createResponseStandard<Variable>(response);
        } catch (error) {
            return createErrorResponseStandard(error);
        }
    }

    async deleteEventVariableById(id: string) {
        try {
            const response: AxiosResponse =
                await eventVariableClient.deleteEventVariableById(id);
            return createResponseStandard(response);
        } catch (error) {
            return createErrorResponseStandard(error);
        }
    }

    async resetEventVariableCurrentValue(id: string) {
        try {
            const response = await eventVariableClient.resetEventVariableById(
                id
            );
            return createResponseStandard(response);
        } catch (error) {
            return createErrorResponseStandard(error);
        }
    }
}

const eventVariableService = new EventVariableService();

export default eventVariableService;
